import { render } from "./MarketPlaceList.vue?vue&type=template&id=77d66d92&scoped=true"
import script from "./MarketPlaceList.vue?vue&type=script&lang=js"
export * from "./MarketPlaceList.vue?vue&type=script&lang=js"

import "./MarketPlaceList.vue?vue&type=style&index=0&id=77d66d92&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d66d92"]])

export default __exports__